import { Button } from '../../components';
import React from 'react';
import Alert from '@material-ui/lab/Alert';
import { GetTutorials, PriceManagementService } from '../../services';
import warning from '../../assets/svg/warning.svg';
import  '../Modal/Modal.global.scss';

interface Props {
  handleModalClose: any;
  id: any;
  fetchPriceList: any;
}

const DeleteTutorialConfirmation: React.FC<Props> = (props: Props) => {
  const {
    handleModalClose,
    id,
    fetchPriceList,
  } = props;

  const [deleted, setDeleted] = React.useState(false);
  const deleteTutorualService = () => {
    GetTutorials
      .deleteTutorials(id)
      .then(() => {
        setDeleted(true);
      });
  };

  return (
    <>
      {!deleted ? (
        <>
          <img src={warning} alt="warning" />
          <h2>
            Delete
          </h2>
          <p>
            Are you sure you want to delete this entry?
          </p>
          <div className="modalButtonWrapper">
            <Button onClick={handleModalClose}>No</Button>
            <Button intent="danger" onClick={deleteTutorualService}>Yes</Button>
          </div>
        </>
      ) : (
        <>
          <h3>
            Deleted successfully !
          </h3>
          <Button onClick={() => {
            handleModalClose();
            fetchPriceList();
          }}
          >
            Ok
          </Button>
        </>
      )}

    </>
  );
};

export default DeleteTutorialConfirmation;
